<template>
    <div>
        <v-app class="login-page">
            <v-main>
                <v-flex pb-3 class="text-xs-center pb-4" style="margin-top: 114px">
                    <div class="text-center pb-4">
                        <img :src="logo_url"/>
                    </div>
                </v-flex>
                <div style="height:8px"/>
                <v-dialog
                    v-model="modalForgetPw"
                    max-width="402px"
                >
                    <v-card class="OpenSans">
                        <v-card-title>
                            <v-row>
                                <v-col class="text-title-modal" cols="12" md="6">
                                    Forget Password
                                </v-col>
                                <v-col class="flex-align-end" cols="12" md="6">
                                    <v-btn
                                        icon
                                        @click="modalForgetPw = false"
                                    >
                                        <v-img src="/icon/close-new.png" max-height="24px" max-width="24px"></v-img>
                                    </v-btn>
                                </v-col>
                            </v-row>
                        </v-card-title>
                        <v-card-text>
                            <span>
                            Silakan hubungi HRD <br>
                            to : <a href="mailto:it.support@edenfarm.id?cc=ba@edenfarm.id;sa@edenfarm.id">it.support@edenfarm.id</a> <br>
                            cc : <a href="mailto:it.support@edenfarm.id?cc=ba@edenfarm.id;sa@edenfarm.id">ba@edenfarm.id</a>, <a href="mailto:it.support@edenfarm.id?cc=ba@edenfarm.id;sa@edenfarm.id">sa@edenfarm.id</a>
                            </span>
                        </v-card-text>
                    </v-card>
                </v-dialog>
                <v-card class="mx-auto rounded-xl OpenSans" max-width="300">
                    <v-container>
                        <div class="d-flex justify-center pt12">
                            <span class="fs14 bold">Dashboard</span>
                        </div>
                        <div class="d-flex justify-center px12 pt24">
                            <v-text-field
                                dense
                                outlined
                                prepend-inner-icon="person_outline"
                                label="Email"
                                name="email"
                                type="text"
                                v-model="form.email"
                                :error-messages="error.password"
                            ></v-text-field>
                        </div>
                        <div class="d-flex justify-center px12 -mt10">
                            <v-text-field
                                outlined
                                dense
                                :append-icon="show ? 'mdi-eye' : 'mdi-eye-off'"
                                :type="show ? 'text' : 'password'"
                                @click:append="show = !show"
                                label="Password"
                                name="password"
                                prepend-inner-icon="mdi-lock-outline"
                                @keyup.enter="onSubmit"
                                :error-messages="error.email"
                                v-model="form.password"
                            ></v-text-field>
                        </div>
                        <div class="d-flex justify-center px12">
                            <v-btn
                                name="loggin-btn"
                                block
                                class="only-btn white--text"
                                depressed
                                color="#50ABA3"
                                :disabled="validation"
                                @click="onSubmit"
                            ><span>Login</span></v-btn
                            >
                        </div>
                        <div class="d-flex justify-center px12 mt16 mb4">
                            <a @click="modalForgetPw = true" style="color:#858585" href="#">Forget Password?</a>
                        </div>
                    </v-container>
                </v-card>
            </v-main>
        </v-app>
        <LoadingBar :value="overlay"/>
    </div>
</template>
<style scoped>
    .login-page {
        background-image: url("/img/bg_login.png");
        background-position: center;
        background-size: cover;
        background-repeat: no-repeat;
        position: relative;
        margin-top : -25px
    }
</style>

<script>
    import axios from 'axios'
    import AuthService from "../services/AuthService.js";

    export default {
        name: "Login",
        data() {
            return {
                modalForgetPw: false,
                form: {
                    email: "",
                    password: "",
                    firebase_token_dashboard : ""
                },
                error: {},
                show: false,
                loading: false,
                overlay: false,
                logo_url: "",
            };
        },
        mounted() {
            let API_URL = process.env.VUE_APP_API_URL
            axios.get(API_URL + '/auth/checkmaintenance').then((response) => {
                return response
            })
        },
        computed: {
            validation() {
                if (this.form.email.length > 0 && this.form.password.length > 0) {
                    return false
                } else {
                    return true
                }
            }
        },
        created() {
            localStorage.setItem('navbar', '')
            let env = process.env.VUE_APP_LOGO_ENV
            if (env == 'dev') {
                this.logo_url = "/img/logo_login_dev.png"
            } else if (env == 'staging') {
                this.logo_url = "/img/logo_login_staging.png"
            } else {
                this.logo_url = "/img/logo_login.png"
            }
        },
        methods: {
            async onSubmit() {
                this.overlay = true
                localStorage.setItem("priv", "");
                // let token = localStorage.getItem('token_firebase')
                // if (token) {
                //     this.form.firebase_token_dashboard = token
                // }
                try {
                    const response = await AuthService.login(this.form);
                    this.msg = response.msg;
                    const token = response.data.token;
                    const staff = response.data.staff;
                    this.$store.dispatch("login", {token, staff});
                    const priv = await this.$http
                        .get("/permission/privilege")
                        .then((response) => response.data);
                    localStorage.setItem("priv", priv.data);
                    if (staff.user.id == 65536) {
                        const navbar = await this.$http
                            .get("/menu")
                            .then((response) => response.data);
                        localStorage.setItem("navbar", JSON.stringify(navbar.data));
                    } else {
                        const navbar = await this.$http
                            .get("/menu/user/" + staff.user.id)
                            .then((response) => response.data);
                        localStorage.setItem("navbar", JSON.stringify(navbar.data));
                    }
                    this.overlay = false
                    this.$router.push("/Home");
                    window.location.reload()
                } catch (error) {
                    this.overlay = false
                    this.error = error.errors ? error.errors : {email: ''};
                }
            },
        },
    };
</script>
